import { Directive, effect, input, signal } from '@angular/core'

import { CardStyles, ContainerStyles, FormStyles, applyTableCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-table',
  host: {
    '[attr.data-uniqueid]': 'componentStyle().uniqueId',
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxTableStyleDirective {
  componentStyle = input<{
    style: ContainerStyles | CardStyles | FormStyles
    uniqueId: string
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(() => {
      const className = applyTableCustomStyles(this.componentStyle().style)
      this.styleClassName.set(className)
    })
  }
}
